<template>
  <div class="info-profile">
    <div class="info-profile__wrap display-flex justify-content-between">

      <b-modal id="modalEditInfoProfile" size="lg" hide-footer>
        <div class="basic-info" v-if="id == 1">
          <!-- {{getBaseInfo}} -->
          <div class="row">

            <!-- <div class="col-12 basic-info__edit text-right">
              <h3 v-if="displayEdit" class="font-size-16 primary-color font-family-Semibold cursor-pointer" @click="displayEditInfo">Chỉnh sửa</h3>
            </div> -->
            <div class="col-12">
              <h2 class="font-sanpro-semibold font-size-24 primary-color-txt text-left">Chỉnh sửa thông tin</h2>
            </div>
            <div class="col-12">
              <div class="edit-avatar position-rel">
                <input @change="onFileChange" id="_imgAvatar" type="file" name="img"
                  class="form-control hidden cursor-pointer" accept="image/*" />
                <!-- <img :src="url_image =='' || url_image == null? imgAvatar : `${appUrl}${url_image}`" /> -->

                <img :src="!url_image ? imgAvatar : `${uploadUrl}/${url_image}`" />

              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view">
              <label class="secondary-color-txt font-sanpro-semibold" for>Họ của bạn <span
                  style="color: red;">*</span></label>
              <br />
              <input type="text" placeholder="Họ của bạn" v-model="firstName" />
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view">
              <label class="secondary-color-txt font-sanpro-semibold" for>Tên của bạn <span
                  style="color: red;">*</span></label>
              <br />
              <input class="primary-color-txt" type="text" placeholder="Tên của bạn" v-model="lastName" />
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view">
              <div class="birthday form-section p-b-17">
                <label for class="lbl-name font-size-16 font-sanpro-semibold secondary-color-txt">Ngày sinh của
                  bạn</label>
                <div class="birthday-form display-flex justify-content-between">
                  <div class="birthday-item">
                    <span class="select-custom">
                      <select v-model="birthDay" name="day"
                        class="form-control form-32h form-bg-gray-light border-rd-10 color-form primary-color-txt">
                        <option value="0">Ngày</option>
                        <option v-for="(day, index) in days" :value="day" :key="index">{{ day }}</option>
                      </select>
                      <i class="fa fa-angle-down" v-if="status"></i>
                    </span>
                  </div>
                  <div class="birthday-item">
                    <span class="select-custom">
                      <select v-model="birthMonth" name="month"
                        class="form-control form-32h form-bg-gray-light border-rd-10 color-form primary-color-txt">
                        <option value="0">Tháng</option>
                        <option selected="selected" v-for="(month, index) in months" :value="month" :key="index">{{ month
                        }}</option>
                      </select>
                      <i class="fa fa-angle-down" v-if="status"></i>
                    </span>
                  </div>
                  <div class="birthday-item">
                    <span class="select-custom">
                      <select v-model="birthYear" name="year"
                        class="form-control form-32h form-bg-gray-light border-rd-10 color-form primary-color-txt">
                        <option value="0">Năm</option>
                        <option selected="selected" v-for="(year, index) in years" :value="year" :key="index">{{ year }}
                        </option>
                      </select>
                      <i class="fa fa-angle-down" v-if="status"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view">
              <div class="gender form-section p-b-17">
                <label class="lbl-name font-size-16 font-sanpro-semibold secondary-color-txt m-b-8">Giới tính</label>
                <br />
                <div class="gender-list display-flex-center justify-content-between">
                  <div class="item" v-for="(item, index) in genderOptions" :key="index">
                    <div class="radio-custom">
                      <input @change="setGenderProfile" type="radio" name="radio"
                        :checked="getBaseInfo && getBaseInfo.gender ? item.value === getBaseInfo.gender : item.value === genderOptions[0].value"
                        :value="item.value" />
                      <label class="color-form">{{ item.text }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view" v-if="authInfo.roleCode === 'TEACHER'">
              <label class="font-size-16 font-sanpro-semibold secondary-color-txt m-b-8">Email</label>
              <br>
              <input class="primary-color-txt" readonly type="text" placeholder="Email của bạn" v-model="emailTeacher" />
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view" v-if="authInfo.roleCode === 'TEACHER'">
              <label class="font-size-16 font-sanpro-semibold secondary-color-txt m-b-8">Số điện thoại</label>
              <br>
              <input class="primary-color-txt" type="text" placeholder="Vui lòng nhập số điện thoại"
                v-model="phoneNumberTeacher" />
            </div>


            <!-- {{authInfo.roleCode}} -->
            <div class="col-lg-6 col-md-6 col-12 basic-info__view">
              <label class="font-sanpro-semibold secondary-color-txt">Thành phố <span style="color: red;">*</span></label>
              <div class="select-custom">
                <select id="city" name="city" v-model="cityUser"
                  class="form-control form-30h form-bg-gray-light border-rd-20 color-form">
                  <option v-for="(item, index) of getALLProvice" :value="item.provinceId" :key="index">
                    {{ item.name }}
                  </option>
                </select>
                <i class="fa fa-angle-down"></i>
              </div>
            </div>
            <div class="col-6"></div>
            <div class="col-12">
              <div class="hr css-hr"></div>
            </div>

            <div class="col-lg-6 col-md-6 col-12 basic-info__view" v-if="authInfo.roleCode === 'PUPIL'">
              <div class="select-status select-status--class">
                <label class="font-sanpro-semibold secondary-color-txt">Lớp <span style="color: red;">*</span></label>
                <select class="form-control" id="status" v-model="classIdUser" @change="handleSelectClass">
                  <option value="0">Lớp - Tất cả</option>
                  <option v-for="(option, index) of getListClass" :key="index" :value="option.classId">{{ option.name }}
                  </option>

                </select>
                <i class="fa fa-angle-down"></i>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view" v-if="authInfo.roleCode === 'TEACHER'">
              <div class="select-status select-status--class">
                <label class="font-sanpro-semibold secondary-color-txt">Cấp dạy <span style="color: red;">*</span></label>
                <select class="form-control" id="status" v-model="schoolType" @change="handleSelectSchoolType">
                  <option :value="0">Chọn cấp dạy</option>
                  <option v-for="(option, index) of listTypeSchool" :key="index" :value="option.schoolTypeId">Giáo viên
                    {{ option.name }}</option>

                </select>
                <i class="fa fa-angle-down"></i>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-12 basic-info__view">
              <label class="font-sanpro-semibold secondary-color-txt">Trường <span
                  style="color: red;">*</span></label><br>
              <input type="text" v-model="schoolName" placeholder="Vui lòng nhập trường" class="css-ipt">
            </div>

            <div class="col-12" v-if="authInfo.roleCode === 'PUPIL'">
              <div class="hr css-hr"></div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 basic-info__view" v-if="authInfo.roleCode === 'PUPIL'">
              <label class="font-sanpro-semibold secondary-color-txt">Email <span style="color: red;">*</span></label><br>
              <input type="text" v-model="parentEmail" readonly placeholder="Vui lòng nhập email" class="css-ipt">
            </div>

            <div class="col-lg-6 col-md-6 col-12 basic-info__view" v-if="authInfo.roleCode === 'PUPIL'">
              <label class="font-sanpro-semibold secondary-color-txt">Số điện thoại <span
                  style="color: red;">*</span></label><br>
              <input type="text" v-model="phoneNumberTeacher" placeholder="Vui lòng nhập số điện thoại" class="css-ipt">
            </div>

          </div>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn close-button font-sanpro-bold primary-color font-size-16"
              data-dismiss="modal" @click="exitForm"> Huỷ </button>
            <button @click="submitInfo" type="submit"
              class="btn btn-main border-rd-20 font-size-16 font-sanpro-semibold p-b p-t">Hoàn thành</button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
const genderOptions = [
  { value: 1, text: "Nam" },
  { value: 2, text: "Nữ" },
  { value: 3, text: "Khác" }
];
import { mapGetters, mapActions } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import Education from "../info-profile/Education";
import Contact from "../info-profile/Contact";
import InfoParents from "../info-profile/InfoParents";
import { getAuth } from '@/utils/jwt'
import moment from "moment";
import { apiGetListSchoolType } from '../../_api'
import { uploadImg } from '@/store/common/api';
import { APP_CONFIG } from "@/utils/constants";
const imgAvatar = require('@/assets/images/user-avatar.png');

export default {
  name: "InfoProfile",
  components: {
    Education,
    Contact,
    InfoParents
  },
  data() {
    return {
      uploadUrl: APP_CONFIG.appUrl,
      imgAvatar,
      isIndexList: true,
      infoList: [
        { id: 1, name: "Thông tin cơ bản" },
        // { id: 2, name: "Học vấn" },
        // { id: 3, name: "Liên hệ" },
        { id: 4, name: "Thông tin phụ huynh" }
      ],
      birthDay: "",
      birthMonth: "",
      birthYear: 0,
      months: 12,
      days: 31,
      status: false,
      disabled: true,
      valueDay: "",
      valueMonth: "",
      valueYear: "",
      genderOptions: genderOptions,
      isShowBasicInfo: true,
      isShowEducation: false,
      isShowContact: false,
      isShowInfoParents: false,
      displayEdit: true,
      id: 1,
      gender: 0,
      lastName: '',
      firstName: '',
      authInfo: {},
      selectClass: 0,
      selectCity: 0,
      getALLProvice: [],
      classIdUser: 0,
      schoolName: '',
      cityUser: 0,
      emailTeacher: '',
      phoneNumberTeacher: '',
      schoolType: 0,
      listTypeSchool: [],
      url_image: '',
      parentName: '',
      parentEmail: '',
      parentPhoneNumber: ''
    };
  },
  watch: {
    getBaseInfo(newVal, oldVal) {
      if (newVal) {
        if (newVal.birthday && newVal.birthday != '1900-01-01T00:00:00') {
          this.birthDay = moment(newVal.birthday).format("D");
          this.birthMonth = moment(newVal.birthday).format("M");
          this.birthYear = moment(newVal.birthday).format("YYYY");
        }
        else {
          this.birthDay = ''
          this.birthMonth = ''
          this.birthYear = ''
        }
        this.gender = newVal.gender;
        this.lastName = newVal.lastName;
        this.firstName = newVal.firstName;
        this.schoolName = newVal.school;
        this.cityUser = newVal.city;
        this.classIdUser = newVal.classId;
        this.phoneNumberTeacher = newVal.phoneNumber;
        this.emailTeacher = newVal.email;
        this.schoolType = newVal.schoolTypeId;
        this.url_image = newVal.avatar;
        this.parentName = newVal.parentName;
        this.parentEmail = newVal.parentEmail
        // this.parentPhoneNumber = newVal.parentPhoneNumber
      }
    },
  },
  created() {
    this.authInfo = getAuth();
    // console.log('authInfo', this.authInfo);
    // console.log('uploadUrl', this.uploadUrl);

    this.actionGetAllProvince()
      .then(res => {
        this.getALLProvice = res.data;
      });
    this.actionGetListTypeSchool().then(res => {
      if (res && res.data) {
        this.listTypeSchool = res.data
      }
    })
  },

  mounted() {
    this.actionGetBaseInfo();
    this.actionGetListClasses();

  },
  computed: {
    ...mapGetters({
      getBaseInfo: STORE_KEY + "/getBaseInfo",
      getParamListelEctricBooks: STORE_KEY + "/getParamListelEctricBooks",
      getListClass: STORE_KEY + "/getListClass",
      getListTypeSchool: STORE_KEY + "/getListTypeSchool",
    }),

    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1945 },
        (value, index) => 1946 + index
      );
    }
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["actionGetBaseInfo", "actionUpdateUserInfo", "actionSetParamListEctricBooks", "actionGetListClasses", "actionGetAllProvince", "actionGetListTypeSchool", "actionGetUserInfo"]),
    ...mapActions(`common`, ["setLoading"]),
    moment,

    onFileChange(e) {
      this.setLoading(true);
      uploadImg(e).then(res => {
        if (res) {
          this.setLoading(false);
          this.url_image = res;
        }
      });
    },

    handleSelectClass() {
      this.actionSetParamListEctricBooks({ ...this.getParamListelEctricBooks, ClassId: this.selectClass });
    },

    handleSelectSchoolType() {
      // console.log('schoolType', this.schoolType);
      this.actionSetParamListEctricBooks({ ...this.getParamListelEctricBooks, schoolTypeId: this.schoolType });
    },

    submitInfo() {
      var data = this.birthYear + "-" + this.birthMonth + "-" + this.birthDay;
      if (!this.birthYear || !this.birthMonth || !this.birthDay) {
        data = null
      }
      this.actionUpdateUserInfo({
        lastName: this.lastName,
        firstName: this.firstName,
        birthday: data,
        gender: this.gender,
        city: this.cityUser,
        school: this.schoolName,
        classId: this.classIdUser,
        email: this.emailTeacher,
        schoolTypeId: this.schoolType,
        phoneNumber: this.phoneNumberTeacher,
        avatar: this.url_image,
        parentName: this.parentName,
        // phoneNumber: this.parentPhoneNumber
      })
        .then(res => {
          if (res && res.status === 'success') {
            this.actionGetBaseInfo();
            this.actionGetUserInfo();
            this.displayEdit = true;
            this.disabled = true;
            this.$toast.success("Cập nhật thành công")
            this.$bvModal.hide('modalEditInfoProfile')
          }
        });
    },
    Displayindex(id, isIndexList) {
      this.id = id;
      this.isIndexList = isIndexList;
    },
    displayEditInfo() {
      this.displayEdit = false;
      this.disabled = false;
    },
    exitForm() {
      // this.displayEdit = true;
      this.$bvModal.hide('modalEditInfoProfile')

    },
    setDay(evt) {
      this.birthDay = evt.target.value;
    },
    setMonth(evt) {
      this.birthMonth = evt.target.value;
    },
    setYear(evt) {
      this.birthYear = evt.target.value;
    },
    setGenderProfile(evt) {
      this.gender = evt.target.value;
      // console.log("this.gender",this.gender)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../../../assets/scss/mixins";
@import "./../../../../assets/scss/variables";
@import "./../../../../assets/scss/general";

.css-hr {
  margin: 15px 0 25px;
  border-top: 1px solid #e6e6e6;
}

input#_imgAvatar {
  position: absolute;
  top: 0;
  display: block;
  opacity: 0;
  width: 165px;
  height: 150px;
  left: 42.5%;
}

.edit-avatar {
  margin-bottom: 25px;

  img {
    width: 147px;
    border: 2px solid #f3f6fb;
    border-radius: 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 147px;
  }
}

.color-form {
  color: #40505E !important;
}

.css-ipt {
  background-color: #f3f6fb;
  border: 0;
  border-radius: 20px;
  padding-left: 15px;
  height: 32px;
  line-height: 32px;
  width: 100%;
  color: #40505E;
}

.select-status {
  position: relative;
  // margin-right: 20px;
}

.select-status select {
  border: none;
  background: #f3f6fb;
  border-radius: 20px;
  height: 30px;
  font-size: 15px;
  -webkit-appearance: none;
}

.select-status i {
  position: absolute;
  top: 34px;
  right: 15px;
  color: #879AA9;
}

.pointer-events {
  pointer-events: none;
  color: #40505E;
}

.container-hts {
  padding-bottom: 100px;
}

.btn-primary {
  height: 30px;
  padding-top: 0px;
  padding-bottom: 0px;
  border-radius: 20px;
}

.w-67 {
  width: 70%;
  margin-top: 18px;
}

.basic-info {
  background: #fff;
  padding: 20px;
  border-radius: 5px;

  label {
    margin-bottom: 5px;
  }

  input {
    background-color: #f3f6fb;
    border: 0;
    border-radius: 20px;
    padding-left: 15px;
    height: 32px;
    line-height: 32px;
    width: 100%;
    color: #40505E;
  }

  &__view {
    margin-bottom: 15px;

    .gender-list {
      padding: 0 35px;
    }
  }
}

ul {
  li {
    @extend .list-style-none;
  }
}

.info-profile__sidebar {
  width: 24%;
  margin-right: 6%;
  margin-top: 18px;

  ul {
    li {
      min-height: 36px;
      padding: 7px 18px;
      @extend .border-rd-8;
      margin-bottom: 2px;
      line-height: 1.2;

      a {
        @extend .secondary-color-txt;
      }

      &.active,
      &:hover {
        background: $btn_hover_color;

        a {
          @extend .primary-color;
          @extend .font-sanpro-semibold;
        }
      }
    }
  }
}

.info-profile__list {
  width: 67%;

  .item {
    padding: 15px 24px;
    background: $color_bg_gray_light;

    &__head {
      border-bottom: 1px solid $secondary_text_color;
      padding-bottom: 13px;
    }

    &__body {
      padding: 10px 0;

      ul {
        li {
          width: 49%;
          display: inline-block;
          margin-bottom: 4px;

          &:nth-child(odd) {
            margin-right: 2%;
          }

          a {
            @extend .secondary-color-txt;
          }
        }
      }
    }

    &:not(:last-child) {
      margin-bottom: 18px;
    }
  }
}

.select-custom select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 20px;
  border-radius: 20px;
  height: 30px;
}

@media (max-width: 1024px) {
  .info-profile__sidebar {
    width: 30%;
    margin-right: 6%;
  }

  input#_imgAvatar {
    left: 36%;
  }
}

@media (max-width: 768px) {
  .info-profile__sidebar {
    width: 30%;
  }

  .basic-info__view .gender-list {
    padding: 0px 5px;
  }

  input#_imgAvatar {
    left: 33%;
  }
}

@media (max-width: 425px) {
  .info-profile {
    &__wrap {
      display: block;
    }

    &__sidebar {
      width: 100%;
      margin-right: 0;
    }

    input#_imgAvatar {
      left: 29%;
    }
  }

  .w-67 {
    width: 100%;
    margin-top: 18px;
  }
}
</style>